"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cosmosDescribePath = void 0;
const utils_1 = require("./utils");
function cosmosDescribePath(path) {
    const pathStr = (0, utils_1.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Atom",
        isKnown: false,
    };
    if (path.length != 5) {
        return unknown;
    }
    if (path[0] != 0x80000000 + 44) {
        return unknown;
    }
    if (path[1] != 0x80000000 + (0, utils_1.slip44ByCoin)("Atom")) {
        return unknown;
    }
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) {
        return unknown;
    }
    if (path[3] !== 0 || path[4] !== 0) {
        return unknown;
    }
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Cosmos Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Atom",
        isKnown: true,
        isPrefork: false,
    };
}
exports.cosmosDescribePath = cosmosDescribePath;
//# sourceMappingURL=cosmos.js.map